import { render } from "./CampaignDetailCard.vue?vue&type=template&id=0b2f0548&scoped=true&ts=true"
import script from "./CampaignDetailCard.vue?vue&type=script&lang=ts"
export * from "./CampaignDetailCard.vue?vue&type=script&lang=ts"

import "./CampaignDetailCard.vue?vue&type=style&index=0&id=0b2f0548&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2f0548"]])

export default __exports__